enum AppointmentType {
  AFTERCARE_FOLLOW_UP = 'AFTERCARE_FOLLOW_UP',
  EXTENDED_FOLLOW_UP = 'EXTENDED_FOLLOW_UP',
  FINAL_APPOINTMENT = 'FINAL_APPOINTMENT',
  FOLLOW_UP = 'FOLLOW_UP',
  HEARING_AID_EVALUATION = 'HEARING_AID_EVALUATION',
  VIDEO_CARE_CALL = 'VIDEO_CARE_CALL',
}

export { AppointmentType }
